import { AttendanceStatus } from '../../types/event';

/** Az eseményre adott visszajelzés címkéje a nevezésnél. */
export const RESPONSE_BADGES: Partial<Record<AttendanceStatus, { label: string; className: string }>> = {
  [AttendanceStatus.Attending]: { label: 'Jön', className: 'bg-green-50 text-green-700 border-green-200' },
  [AttendanceStatus.NotAttending]: { label: 'Nem jön', className: 'bg-red-50 text-red-700 border-red-200' },
  [AttendanceStatus.Maybe]: { label: 'Talán', className: 'bg-amber-50 text-amber-700 border-amber-200' },
};
